export default "__VITE_ASSET__DtNyjOGX__"